/* eslint-disable no-restricted-imports -- Icon package is the only allowed @fortawesome entry point (see eslint.config.mjs). */
import {
  faArrowsRepeat as solidArrowsRepeat,
  faArrowUpRightFromSquare as solidArrowUpRightFromSquare,
  faCaretDown as solidCaretDown,
  faChartPyramid as solidChartPyramid,
  faCheck as solidCheck,
  faCheckCircle as solidCheckCircle,
  faChevronDown as solidChevronDown,
  faChevronLeft as solidChevronLeft,
  faChevronRight as solidChevronRight,
  faChevronUp as solidChevronUp,
  faCircle as solidCircle,
  faCircleCheck as solidCircleCheck,
  faCircleExclamation as solidCircleExclamation,
  faCircleInfo as solidCircleInfo,
  faCircleMinus as solidCircleMinus,
  faCircleXmark as solidCircleXmark,
  faCloudArrowUp as solidCloudArrowUp,
  faDoNotEnter as solidDoNotEnter,
  faDownload as solidDownload,
  faEnvelope as solidEnvelope,
  faExclamationTriangle as solidExclamationTriangle,
  faFaceLaughSquint as solidFaceLaughSquint,
  faFaceSmile as solidFaceSmile,
  faFlag as solidFlag,
  faHospital as solidHospital,
  faMoon as solidMoon,
  faPaperclip as solidPaperclip,
  faPen as solidPen,
  faPencil as solidPencil,
  faPlus as solidPlus,
  faShuffle as solidShuffle,
  faSun as solidSun,
  faSunset as solidSunset,
  faTimesCircle as solidTimesCircle,
  faTrash as solidTrash,
  faTrashCan as solidTrashCan,
  faTriangleExclamation as solidTriangleExclamation,
  faUndo as faUndo,
  faXmarkCircle as solidXmarkCircle,
  faXmark as solidXmark,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faAngleRight as lightAngleRight,
  faArrowRight as lightArrowRight,
  faArrowUpFromBracket as lightArrowUpFromBracket,
  faArrowUpRightFromSquare as lightArrowUpRightFromSquare,
  faBedPulse as lightBedPulse,
  faBirthdayCake as lightBirthdayCake,
  faBriefcaseMedical as lightBriefcaseMedical,
  faBuilding as lightBuilding,
  faCalendar as lightCalendar,
  faCalendarAlt as lightCalendarAlt,
  faCalendarCheck as lightCalendarCheck,
  faChartBar as lightChartBar,
  faCheck as lightCheck,
  faClinicMedical as lightClinicMedical,
  faChevronDown as lightChevronDown,
  faChevronRight as lightChevronRight,
  faChevronUp as lightChevronUp,
  faCircleCheck as lightCircleCheck,
  faCircleInfo as lightCircleInfo,
  faClock as lightClock,
  faClipboardListCheck as lightClipboardListCheck,
  faCloudDownloadAlt as lightCloudDownloadAlt,
  faColumns3 as lightColumns3,
  faCommentAltSmile as lightCommentAltSmile,
  faCopy as lightCopy,
  faDollarSign as lightDollarSign,
  faEnvelope as lightEnvelope,
  faEnvelopes as lightEnvelopes,
  faEye as lightEye,
  faEyeSlash as lightEyeSlash,
  faFaceLaughSquint as lightFaceLaughSquint,
  faFaceSmile as lightFaceSmile,
  faFileAlt as lightFileAlt,
  faFileCheck as lightFileCheck,
  faFileExport as lightFileExport,
  faFileInvoice as lightFileInvoice,
  faFileInvoiceDollar as lightFileInvoiceDollar,
  faFilePdf as lightFilePdf,
  faFileSearch as lightFileSearch,
  faHand as lightHand,
  faHomeAlt as lightHomeAlt,
  faHospital as lightHospital,
  faHospitals as lightHospitals,
  faHospitalWide as lightHospitalWide,
  faHospitalUser as lightHospitalUser,
  faIdCard as lightIdCard,
  faIdCardAlt as lightIdCardAlt,
  faLock as lightLock,
  faLockKeyhole as lightLockKeyhole,
  faLongArrowLeft as lightLongArrowLeft,
  faLongArrowRight as lightLongArrowRight,
  faMapMarkerAlt as lightMapMarkerAlt,
  faMobile as lightMobile,
  faPaperPlane as lightPaperPlane,
  faPaperclip as lightPaperclip,
  faPaperclipVertical as lightPaperclipVertical,
  faPencil as lightPencil,
  faPeopleGroup as lightPeopleGroup,
  faPlaneArrival as lightPlaneArrival,
  faPlus as lightPlus,
  faPollPeople as lightPollPeople,
  faRightFromBracket as lightRightFromBracket,
  faSearch as lightSearch,
  faShieldCheck as lightShieldCheck,
  faShuffle as lightShuffle,
  faSliders as lightSliders,
  faSlidersUp as lightSlidersUp,
  faSuitcase as lightSuitcase,
  faTimer as lightTimer,
  faTrashCan as lightTrashCan,
  faUnlock as lightUnlock,
  faUpload as lightUpload,
  faUser as lightUser,
  faUserCheck as lightUserCheck,
  faUserClock as lightUserClock,
  faUserCog as lightUserCog,
  faUserGear as lightUserGear,
  faUserMd as lightUserMd,
  faUserNurse as lightUserNurse,
  faUserPlus as lightUserPlus,
  faUsers as lightUsers,
  faUsersMedical as lightUsersMedical,
  faUserXmark as lightUserXmark,
  faWandMagicSparkles as lightWandMagicSparkles,
  faXmark as lightXmark,
} from '@fortawesome/pro-light-svg-icons';
import {
  faArrowDownToBracket as regularArrowDownToBracket,
  faArrowLeft as regularArrowLeft,
  faArrowRight as regularArrowRight,
  faArrowUpFromBracket as regularArrowUpFromBracket,
  faBan as regularBan,
  faBars as regularBars,
  faChevronDown as regularChevronDown,
  faChevronUp as regularChevronUp,
  faCircle as regularCircle,
  faCircleCheck as regularCircleCheck,
  faCircleX as regularCircleX,
  faCloudUpload as regularCloudUpload,
  faCopy as regularCopy,
  faCommentAltSmile as regularCommentAltSmile,
  faDownload as regularDownload,
  faEllipsis as regularEllipsis,
  faEllipsisVertical as verticalEllipsis,
  faExternalLink as regularExternalLink,
  faFaceLaughSquint as regularFaceLaughSquint,
  faFaceSmile as regularFaceSmile,
  faHouseChimneyMedical as regularHouseChimneyMedical,
  faPencil as regularPencil,
  faPlus as regularPlus,
  faQuestionCircle as regularQuestionCircle,
  faSync as regularSync,
  faTimesCircle as regularTimesCircle,
  faTrash as regularTrash,
  faXmark as regularXmark,
} from '@fortawesome/pro-regular-svg-icons';

// eslint-disable-next-line import-x/no-extraneous-dependencies
import type { IconDefinition } from '@fortawesome/fontawesome-common-types';

/*
 * Need a new icon? Import it right above following the pattern
 * and add it on in ICONS_MAP constant to publish it.
 *
 * Please mind the alphabetical order.
 */

export const ICONS_MAP = {
  solid: {
    arrowsRepeat: solidArrowsRepeat,
    arrowUpRightFromSquare: solidArrowUpRightFromSquare,
    caretDown: solidCaretDown,
    chartPyramid: solidChartPyramid,
    check: solidCheck,
    checkCircle: solidCheckCircle,
    chevronDown: solidChevronDown,
    chevronLeft: solidChevronLeft,
    chevronRight: solidChevronRight,
    chevronUp: solidChevronUp,
    circle: solidCircle,
    circleCheck: solidCircleCheck,
    circleExclamation: solidCircleExclamation,
    circleInfo: solidCircleInfo,
    circleMinus: solidCircleMinus,
    circleXmark: solidCircleXmark,
    cloudArrowUp: solidCloudArrowUp,
    doNotEnter: solidDoNotEnter,
    download: solidDownload,
    envelope: solidEnvelope,
    exclamationTriangle: solidExclamationTriangle,
    faceLaughSquint: solidFaceLaughSquint,
    faceSmile: solidFaceSmile,
    flag: solidFlag,
    moon: solidMoon,
    hospital: solidHospital,
    paperclip: solidPaperclip,
    pen: solidPen,
    pencil: solidPencil,
    plus: solidPlus,
    shuffle: solidShuffle,
    sun: solidSun,
    sunset: solidSunset,
    timesCircle: solidTimesCircle,
    trash: solidTrash,
    trashCan: solidTrashCan,
    triangleExclamation: solidTriangleExclamation,
    xmarkCircle: solidXmarkCircle,
    xMark: solidXmark,
    undo: faUndo,
  },
  light: {
    angleRight: lightAngleRight,
    arrowRight: lightArrowRight,
    arrowUpFromBracket: lightArrowUpFromBracket,
    arrowUpRightFromSquare: lightArrowUpRightFromSquare,
    bedPulse: lightBedPulse,
    birthdayCake: lightBirthdayCake,
    briefcaseMedical: lightBriefcaseMedical,
    building: lightBuilding,
    calendar: lightCalendar,
    calendarAlt: lightCalendarAlt,
    calendarCheck: lightCalendarCheck,
    chartBar: lightChartBar,
    check: lightCheck,
    clinicMedical: lightClinicMedical,
    chevronDown: lightChevronDown,
    chevronRight: lightChevronRight,
    chevronUp: lightChevronUp,
    circleCheck: lightCircleCheck,
    circleInfo: lightCircleInfo,
    clock: lightClock,
    clipboardListCheck: lightClipboardListCheck,
    cloudDownloadAlt: lightCloudDownloadAlt,
    columns3: lightColumns3,
    commentAltSmile: lightCommentAltSmile,
    copy: lightCopy,
    dollarSign: lightDollarSign,
    envelope: lightEnvelope,
    envelopes: lightEnvelopes,
    eye: lightEye,
    eyeSlash: lightEyeSlash,
    faceLaughSquint: lightFaceLaughSquint,
    faceSmile: lightFaceSmile,
    fileAlt: lightFileAlt,
    fileCheck: lightFileCheck,
    fileExport: lightFileExport,
    fileInvoice: lightFileInvoice,
    fileInvoiceDollar: lightFileInvoiceDollar,
    filePdf: lightFilePdf,
    fileSearch: lightFileSearch,
    hand: lightHand,
    homeAlt: lightHomeAlt,
    hospital: lightHospital,
    hospitals: lightHospitals,
    hospitalUser: lightHospitalUser,
    hospitalWide: lightHospitalWide,
    idCard: lightIdCard,
    idCardAlt: lightIdCardAlt,
    lock: lightLock,
    lockKeyhole: lightLockKeyhole,
    longArrowLeft: lightLongArrowLeft,
    longArrowRight: lightLongArrowRight,
    mapMarkerAlt: lightMapMarkerAlt,
    mobile: lightMobile,
    paperPlane: lightPaperPlane,
    paperclip: lightPaperclip,
    paperclipVertical: lightPaperclipVertical,
    pencil: lightPencil,
    peopleGroup: lightPeopleGroup,
    planeArrival: lightPlaneArrival,
    plus: lightPlus,
    pollPeople: lightPollPeople,
    rightFromBracket: lightRightFromBracket,
    search: lightSearch,
    shieldCheck: lightShieldCheck,
    shuffle: lightShuffle,
    sliders: lightSliders,
    slidersUp: lightSlidersUp,
    suitcase: lightSuitcase,
    timer: lightTimer,
    trashCan: lightTrashCan,
    unlock: lightUnlock,
    upload: lightUpload,
    user: lightUser,
    users: lightUsers,
    usersMedical: lightUsersMedical,
    userMd: lightUserMd,
    userNurse: lightUserNurse,
    userPlus: lightUserPlus,
    userCheck: lightUserCheck,
    userClock: lightUserClock,
    userCog: lightUserCog,
    userGear: lightUserGear,
    userXmark: lightUserXmark,
    wandMagicSparkles: lightWandMagicSparkles,
    xMark: lightXmark,
  },
  regular: {
    arrowDownToBracket: regularArrowDownToBracket,
    arrowLeft: regularArrowLeft,
    arrowRight: regularArrowRight,
    arrowUpFromBracket: regularArrowUpFromBracket,
    ban: regularBan,
    bars: regularBars,
    chevronDown: regularChevronDown,
    chevronUp: regularChevronUp,
    circle: regularCircle,
    circleCheck: regularCircleCheck,
    circleX: regularCircleX,
    cloudUpload: regularCloudUpload,
    commentAltSmile: regularCommentAltSmile,
    ellipsis: regularEllipsis,
    externalLink: regularExternalLink,
    copy: regularCopy,
    download: regularDownload,
    faceLaughSquint: regularFaceLaughSquint,
    faceSmile: regularFaceSmile,
    houseChimneyMedical: regularHouseChimneyMedical,
    pencil: regularPencil,
    plus: regularPlus,
    sync: regularSync,
    questionCircle: regularQuestionCircle,
    timesCircle: regularTimesCircle,
    trash: regularTrash,
    verticalEllipsis: verticalEllipsis,
    xMark: regularXmark,
  },
};

export type AvailableIcons =
  | keyof typeof ICONS_MAP.solid
  | keyof typeof ICONS_MAP.light
  | keyof typeof ICONS_MAP.regular;

export type IconOfKind =
  | { kind?: 'solid'; icon: keyof (typeof ICONS_MAP)['solid'] }
  | { kind: 'regular'; icon: keyof (typeof ICONS_MAP)['regular'] }
  | { kind: 'light'; icon: keyof (typeof ICONS_MAP)['light'] };

export function getIcon({ kind, icon }: IconOfKind): IconDefinition {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: not worth to prove correctness here.
  return ICONS_MAP[kind || 'solid']?.[icon];
}
